var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_1928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C5.87875 0 3.8425 0.843375 2.34375 2.34313C0.843465 3.84348 0.000429311 5.87823 0 8C0 10.1209 0.84375 12.1571 2.34375 13.6569C3.8425 15.1566 5.87875 16 8 16C10.1212 16 12.1575 15.1566 13.6562 13.6569C15.1562 12.1571 16 10.1209 16 8C16 5.87913 15.1562 3.84288 13.6562 2.34313C12.1575 0.843375 10.1212 0 8 0Z",
    fill: "url(#paint0_linear_981_1928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62107 7.91602C5.95357 6.90002 7.50857 6.23018 8.28607 5.90652C10.5086 4.98239 10.9698 4.82189 11.2711 4.81645C11.3373 4.81539 11.4848 4.83177 11.5811 4.90958C11.6611 4.9752 11.6836 5.06395 11.6948 5.12627C11.7048 5.18852 11.7186 5.33039 11.7073 5.44114C11.5873 6.70614 11.0661 9.77589 10.8011 11.1928C10.6898 11.7923 10.4686 11.9933 10.2548 12.0129C9.78982 12.0556 9.43732 11.7059 8.98732 11.411C8.28357 10.9494 7.88607 10.6621 7.20232 10.2118C6.41232 9.69127 6.92482 9.40514 7.37482 8.93764C7.49232 8.81527 9.53982 6.95339 9.57857 6.78452C9.58357 6.76339 9.58857 6.68464 9.54107 6.64314C9.49482 6.60152 9.42607 6.61577 9.37607 6.62702C9.30482 6.64302 8.18107 7.38652 6.00107 8.85739C5.68232 9.07664 5.39357 9.18352 5.13357 9.17789C4.84857 9.17177 4.29857 9.01639 3.88982 8.88364C3.38982 8.72077 2.99107 8.63464 3.02607 8.35802C3.04357 8.21402 3.24232 8.06664 3.62107 7.91602Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_981_1928",
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 1600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_1928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.723db53cfd9501f6b45513f72a268751.svg";
export { ForwardRef as ReactComponent };